import { Component, Input } from '@angular/core';
import { I18nService } from '../../core/i18n.service';

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  templateUrl: './loading-spinner.html',
  styleUrl: './loading-spinner.scss'
})
export class LoadingSpinner {
  @Input() label = '';

  constructor(private i18n: I18nService) {}

  get displayLabel(): string {
    return this.label || this.i18n.t('common.loadingPage');
  }
}